import { createApp } from 'vue'
import SearchFilteredTags from './SearchFilteredTags'

const el = '.kb-component--search-filtered-tags'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((SearchFilteredTagsDOM) => {
            const guids = SearchFilteredTagsDOM.dataset.guids
                ? JSON.parse(SearchFilteredTagsDOM.dataset.guids)
                : []
            const component = createApp(SearchFilteredTags, { guids }).use(
                Store
            )
            component.mount(SearchFilteredTagsDOM)
        })
    }
}
